<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='规范管理' label2="规范信息详细" url="/standard/standardlist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">专业：</label>
            <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
              {{form.spname}}
            </div>
            <label class="col-xl-1 col-form-label">届别：</label>
            <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
              {{form.standardyearname}}
            </div>
            <label class="col-xl-1 col-form-label">规范名称：</label>
            <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
              {{form.standardname}}
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">规范说明：</label>
            <div class="col-xl-6" style="text-align: left;padding-top: 8px;">
              {{form.standardremark}}
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-xl-1">
            </div>
            <div class="col-xl-10">
              <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                <el-table v-loading="loading" :data="ssData" stripe style="width: 100%" size="medium">
                  <el-table-column prop="SecName" label="科室">
                  </el-table-column>
                  <el-table-column prop="SSTime" label="轮转时间">
                    <template slot-scope="scope">
                      {{scope.row.SSTime}}月
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="col-xl-1">
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StandardEdit',
    data() {
      return {
        form: {
          id: '',
          standardname: '',
          spname: '',
          standardyearname: '',
          standardremark: '',
          token: ''
        },
        ssData: null,
        loading: true
      }
    },
    methods: {
      LoadStandardInfo: function() {
        var args = {
          id: this.form.id,
          token: this.form.token
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStandard/ViewInfo', args, function(data, model) {
          model.standardname = data.Data.StandardName
          model.spname = data.Data.SpName
          model.standardyearname = data.Data.StandardYearName
          model.standardremark = data.Data.StandardRemark
        }, null, null, this.form)
      },
      LoadStardardSection: function() {
        var args = {
          standardid: this.form.id,
          token: this.form.token,
          pageSize: 99999,
          currentPage: 1
        }
        this.loading = true
        this.$http.post(this.$utils.Url.zpgl + '/api/APIStandardSection/List', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.ssData = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.ssData = null
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      this.LoadStandardInfo()
      this.LoadStardardSection()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .m-form.m-form--group-seperator-dashed .m-form__group {
    border-bottom: 0;
  }
</style>
